import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ItiMenuItem } from '..';

@Component({})
export default class ItiMenuOption extends Vue {
  @Prop() public item!: ItiMenuItem;
  public clave: string = 'message';
}
